import React, { Component } from "react";
import { Popup, PopupContainer, PopupContent } from "../../Components/Popup";
import { AiIcon, SlideAiButton } from "./SlideAiIcon";
import { $, _ } from "js/vendor";
import styled from "styled-components";
import { CanvasEventType } from "../../../common/constants";
import { CategoryController } from "../../../common/SlideCategories/CategoryController";
import { computeChangeSet, mergeChanges } from "../../../common/utils/changeset";
import { findElementsWithImages } from "../../../common/utils/findElementsWithImages";
import AiGenerationService from "../../core/services/aiGeneration";
import CanvasPreview from "../../react/components/CanvasPreview";
import { themeColors } from "../../react/sharedStyles";
import { Button } from "../../Components/Button";
import { FlexSpacer, Gap10 } from "../../react/components/Gap";
import { BeautifulDialog, ShowDialog, ShowWarningDialog } from "../../react/components/Dialogs/BaseDialog";
import { AiSlideContentEditor } from "../AiGeneration/GeneratePresentation/Components/AiSlideContentEditor";
import { WithLabel } from "../../Components/WithLabel";
import { FlexBox } from "../../react/components/LayoutGrid";
import { PropertyPanelContainer, PropertySection } from "../../EditorComponents/PropertyPanel";
import { ToggleSwitch } from "../../Components/ToggleSwitch";
import GeneratePresentationController from "../AiGeneration/GeneratePresentation/GeneratePresentationController";
import { Dropdown } from "../../Components/Dropdown";
import { MenuItem } from "../../Components/Menu";
import { Icon } from "../../Components/Icon";
import { Key } from "../../core/utilities/keys";
import { AiGenerateProgress } from "../AiGeneration/GeneratePresentation/Components/AiGenerateProgress";
import { IconButton } from "../../Components/IconButton";
import SlideAiIdeasList, { SlideAiIdeasListContainer } from "./SlideAiIdeasList";
import SlideAiController from "./SlideAiController";

const SLIDE_GAP = 20;

const Container = styled.div`
    width: 100%;
    height: 80vh;
    display: grid;
    grid-template-areas: 
"header"
"options"
"slides";
    grid-template-rows: 50px auto 1fr;
`;

const Header = styled.div`
    background: white;
    color: #333;
    font-weight: bold;
    font-size: 18px;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
`;

const PromptContainer = styled.div`
    grid-area: options;
    padding: 10px 20px;
    background: #f1f1f1;
`;

const TextContainer = styled.div`
    background: #fff;
    border: solid 1px #ccc;
    padding: 10px;
    width: 100%;
    min-height: 100px;
    pointer-events: auto;
`;

class SlideAiDialog extends Component {
    constructor(props) {
        super(props);

        let metadata = props.currentSlide.getMetadata() ?? {
            title: "Loading..."
        };

        let prompt;

        if (metadata.slidePrompt) {
            prompt = metadata.slidePrompt;

            if (typeof prompt === "object") {
                prompt = JSON.stringify(prompt, null, 2);
            }
        } else {
            prompt = props.currentSlide.getSlideText().trim();
        }
        // prompt = marked.parse(prompt);

        // prompt = markdownToTxt(prompt, { gfm: true, breaks: true});
        // prompt = markdownToTxt(prompt);

        this.state = {
            currentModel: _.cloneDeep(props.currentSlide.attributes),
            isGenerating: false,
            selectedModel: null,
            textDensity: 1,
            slideCategory: null,
            originalSlidePrompt: metadata.originalSlidePrompt,
            slidePrompt: prompt,
            slideType: "auto",
            preserveExactText: !!metadata.preserveExactText,
            usePresentationAsContext: true,
            regenImage: false,
            files: metadata.files ? metadata.files.map(f => f.hasBeenUsedFor === "slide" ? ({ ...f, hasBeenUsed: false }) : f) : [],
            isDragging: false,
            isSavingFiles: false,
            slideWidth: (window.innerWidth - SLIDE_GAP * 4 - 64) / 3 - 10,
            ideas: metadata.generatedSlides || [],
        };

        // this.hasBeenUnmounted = false;

        this.promptRef = React.createRef();
    }

    componentDidMount() {
        const { currentSlide, currentCanvasController } = this.props;

        if (SlideAiController.currentSlide !== currentSlide) {
            SlideAiController.setCurrentSlide(currentSlide, currentCanvasController);
        }

        $(window).on("keydown", event => {
            if (event.which == Key.ESCAPE) {
                this.props.closeDialog();
            }
        });
    }

    regenerateSlide = async () => {
        this.setState({ isGenerating: true });
        await SlideAiController.regenerateIdeas(this.promptRef.current.getMarkdown(), {
            slideType: this.state.slideType,
            preserveExactText: this.state.preserveExactText,
            usePresentationAsContext: this.state.usePresentationAsContext,
            files: this.state.files,
        });
        this.setState({ isGenerating: false });
    }

    handleApplySlide = model => {
        const { currentSlide, currentCanvasController, closePopup } = this.props;

        currentCanvasController.canvas.once(CanvasEventType.REFRESH, () => {
            this.props.closeDialog();
            // window.requestAnimationFrame(() => {
            //     PresentationEditorController.playAnimation();
            // });
        });

        currentSlide.update({
            ...currentSlide.attributes,
            animations: {},
            states: model.states,
            layout: model.layout,
            template_id: model.template_id,
            version: 10,
            migrationVersion: 10.03,
            metadata: {
                ...model.metadata,
                needsLayoutProcessing: true
            }
        }, { removeMissingKeys: true });
    }

    render() {
        let { isGenerating, slidePrompt, preserveExactText, usePresentationAsContext, slideType, regenImage, language } = this.state;

        return (
            <BeautifulDialog closeDialog={this.props.closeDialog} maxWidth="xl">
                <Container>
                    <Header>
                        <AiIcon contained size={20} /> Slide AI
                        <FlexSpacer />
                        <IconButton icon="close" onClick={this.props.closeDialog} />
                    </Header>
                    <PromptContainer>
                        <WithLabel label="Slide Prompt" above left>
                            {/*<TextField variant="outlined" multiline fullWidth*/}
                            {/*           value={slidePrompt} onChange={slidePrompt => this.setState({ slidePrompt })}*/}
                            {/*           style={{ background: "white", userSelect: "text" }}*/}
                            {/*/>*/}

                            <TextContainer>
                                <AiSlideContentEditor ref={this.promptRef} text={slidePrompt} onChange={slidePrompt => this.setState({ slidePrompt })} />
                            </TextContainer>
                        </WithLabel>
                        <Gap10 />
                        <FlexBox left middle fillWidth gap={20}>
                            {/*<Button onClick={this.regenerateSlide}>Regenerate Slide Ideas</Button>*/}
                            <FlexSpacer />
                            <WithLabel label="Slide Type">
                                <Dropdown value={slideType} onChange={slideType => this.setState({ slideType })}>
                                    <MenuItem value="auto">Auto Detect</MenuItem>
                                    <MenuItem value="title">Title Slide</MenuItem>
                                    <MenuItem value="table">Table</MenuItem>
                                </Dropdown>
                            </WithLabel>
                            <WithLabel right tight label="Use Presentation Context" toolTip="Generate this slide using the context of the entire presentation.">
                                <ToggleSwitch value={usePresentationAsContext} onChange={usePresentationAsContext => this.setState({ usePresentationAsContext })} />
                            </WithLabel>
                            <WithLabel right tight label="Preserve Exact Text" toolTip="Try to keep the text in the generated slides exactly as it appears in the prompt.">
                                <ToggleSwitch value={preserveExactText} onChange={preserveExactText => this.setState({ preserveExactText })} />
                            </WithLabel>
                            {/*<WithLabel right tight label="Regenerate Image">*/}
                            {/*    <ToggleSwitch value={regenImage} onChange={regenImage => this.setState({ regenImage })} />*/}
                            {/*</WithLabel>*/}
                            {/*<Popup label="Regenerate Options" showArrow>*/}
                            {/*    <PopupContent>*/}
                            {/*        {closePopup => (*/}
                            {/*            <PopupContainer>*/}
                            {/*                <PropertyPanelContainer>*/}
                            {/*                    <PropertySection>*/}
                            {/*                        <WithLabel label="Preserve Exact Text" toolTip="Try to keep the text in the generated presentation slides exactly as it appears in the outline.">*/}
                            {/*                            <ToggleSwitch value={preserveExactText} onChange={value => GeneratePresentationController.setPreserveExactText(value)} />*/}
                            {/*                        </WithLabel>*/}
                            {/*                    </PropertySection>*/}
                            {/*                    <PropertySection>*/}
                            {/*                        <WithLabel label="Language">*/}
                            {/*                            <Dropdown value={language} onChange={value => GeneratePresentationController.setLanguage(value)}>*/}
                            {/*                                <MenuItem value="eng">English</MenuItem>*/}
                            {/*                                <MenuItem value="es">Spanish</MenuItem>*/}
                            {/*                                <MenuItem value="fr">French</MenuItem>*/}
                            {/*                                <MenuItem value="de">German</MenuItem>*/}
                            {/*                            </Dropdown>*/}
                            {/*                        </WithLabel>*/}
                            {/*                    </PropertySection>*/}
                            {/*                </PropertyPanelContainer>*/}
                            {/*            </PopupContainer>*/}
                            {/*        )}*/}
                            {/*    </PopupContent>*/}
                            {/*</Popup>*/}
                            <Button large color={themeColors.aiColor} onClick={this.regenerateSlide} height={48}>
                                <Icon>
                                    <AiIcon />
                                </Icon>Generate Slide Ideas
                            </Button>
                        </FlexBox>
                    </PromptContainer>
                    <SlideAiIdeasList
                        isGenerating={isGenerating}
                        onSelect={this.handleApplySlide}
                    />
                </Container>
            </BeautifulDialog>
        );
    }
}

export default SlideAiController.withState(SlideAiDialog);

